<template>
    <div>
        <template v-if="this.loading">
            <loading-spinner />
        </template>

        <template v-else>
            <x-layout v-if="!this.showNote">
                <x-flex text-xs-center>
                    <x-btn color="secondary" class="new-note" @click="open()">
                        <i class="material-icons mr-2">note_add</i>

                        Add note
                    </x-btn>
                </x-flex>
            </x-layout>


            <template v-else>
                <x-layout>
                    <x-flex>
                        <x-textarea
                            class="textarea-note"
                            name="note"
                            v-model="note"
                            :label="notesLabel"
                        />
                    </x-flex>
                </x-layout>

                <x-layout justify-end>
                    <x-flex class="grow-0">
                        <x-btn @click="remove()" small color="tertiary">
                            <x-icon class="mr-2">delete</x-icon> Remove
                        </x-btn>
                    </x-flex>

                    <x-flex class="grow-0">
                        <x-btn @click="save()" small :disabled="!isDirty" color="secondary">
                            Save
                        </x-btn>
                    </x-flex>
                </x-layout>
            </template>
        </template>
    </div>
</template>

<script>
    export default {
        name: "SubmissionNote",
        props: ['submissionId'],
        data() {
            return {
                showNote: false, // switch display note
                isNewNote: true, // check if note is going to be updated on DB or not
                loading: true,
                note: null,
                storedNote: null,
            }
        },
        async created() {
            if (this.submissionId) {
                let noteData = (await axios.get(`/api/insurer/submission/${this.submissionId}/note`)).data.data;
                // Check if exist on DB
                if (Object.keys(noteData).length !== 0) {
                    this.storedNote = noteData;
                    this.note = noteData.note;
                    this.showNote = this.note.length > 0;
                    this.isNewNote = false;
                }
            }
            this.loading = false;
        },
        methods: {
            open() {
                this.showNote = true;
            },
            save() {
                if (!this.isDirty) {
                    return;
                }
                const data = {
                    note: this.note
                };
                if (this.isNewNote) {
                    axios.post(`/api/insurer/submission/${this.submissionId}/note`, data)
                        .then(function (response) {
                            this.storedNote = response.data.data;
                            this.note = response.data.data.note;
                            this.submissionId = response.data.data.submission_id;
                            this.isNewNote  = false;
                        }.bind(this));
                } else {
                    axios.put(`/api/insurer/submission/${this.submissionId}/note/${this.storedNote.id}`, data)
                        .then(function (response) {
                            this.storedNote = response.data.data;
                            this.note = response.data.data.note;
                        }.bind(this));
                }
            },
            remove() {
                axios.delete(`/api/insurer/submission/${this.submissionId}/note/${this.storedNote.id}`);
                this.note = '';
                this.showNote = false;
                this.isNewNote  = true;
            },
        },
        computed: {
            isDirty() {
                return this.storedNote?.note !== this.note;
            },
            notesLabel() {
                return this.isDirty ? ' (unsaved changes)' : ' ';
            }
        }
    }
</script>